import { Stack } from "@mui/material";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";
import AssetAndChildrenCard, {
  AssetAndChildrenCardDeleteProps,
  AssetAndChildrenCardEditProps,
  AssetAndChildrenCardNoneProps,
  AssetAndChildrenCardSelectProps,
} from "./asset-and-children-card";

interface AssetAndChildrenListBaseProps {
  assets: DbAssetObjectInfos[];
}

export type AssetAndChildrenListProps =
  | (AssetAndChildrenListBaseProps & Omit<AssetAndChildrenCardNoneProps, "asset">)
  | (AssetAndChildrenListBaseProps & Omit<AssetAndChildrenCardSelectProps, "asset">)
  | (AssetAndChildrenListBaseProps & Omit<AssetAndChildrenCardEditProps, "asset">)
  | (AssetAndChildrenListBaseProps & Omit<AssetAndChildrenCardDeleteProps, "asset">);

const AssetAndChildrenList = (props: AssetAndChildrenListProps) => {
  const { assets, action } = props;

  return (
    <Stack spacing={0.5}>
      {assets.map((asset, index) => {
        switch (action) {
          case "select":
            return (
              <AssetAndChildrenCard
                key={index}
                asset={asset}
                action="select"
                selected={props.selected}
                onSelect={props.onSelect}
              />
            );
          case "edit":
            return <AssetAndChildrenCard key={index} asset={asset} action="edit" onEdit={props.onEdit} />;
          case "delete":
            return <AssetAndChildrenCard key={index} asset={asset} action="delete" onDelete={props.onDelete} />;
          default:
            return <AssetAndChildrenCard key={index} asset={asset} />;
        }
      })}
    </Stack>
  );
};

export default AssetAndChildrenList;
